import { firebaseDB } from '@/firebase';
import { IUser, User } from '@/models/User';
import api from '@/api';
import constants from '@/utils/constants'
// @ts-ignore
import roles from '../roles.json';

export default {
  LOAD_CURRENT_USER({ commit }, { uid, route }) {
    if (uid.length === 0) {
      commit('UPDATE_CURRENT_USER', null);
      commit('UPDATE_AUTO_PRINT', null);
      commit('SET_IS_PAGE_LOADING_USER', false); // Change user loading state
      return;
    }
    commit('SET_IS_PAGE_LOADING_USER', true);
    firebaseDB
      .collection('BACKOFFICE_USERS')
      .where('UID', '==', uid)
      .get()
      .then(result => {
        if (result.empty) {
          commit('UPDATE_CURRENT_USER', null);
          commit('UPDATE_AUTO_PRINT', null);
        } else {
          const data = result.docs[0].data();
          const user: IUser = {
            LoginID: result.docs[0].id,
            UID: data.UID,
            Type: data.Type,
            UserName: data.UserName,
            Email: data.Email,
            OutletCodes: data.OutletCodes,
            CreatedAt: data.CreatedAt,
            UpdatedAt: data.UpdatedAt
          };
          const t = data.Type.toLocaleLowerCase();
          let permission = roles[t][route.fullPath];
          if (
            route.matched &&
            route.matched.some(record => record.path.includes(':id') === true)
          ) {
            const p = route.matched.filter(x => x.path.includes(':id'));
            permission = roles[t][p[0].path];
          }
          commit('USER_PAGE_PERMISSION', permission);
          commit('UPDATE_CURRENT_USER', user);
          /* if (data.OutletCodes && data.OutletCodes.length) {
            api.GetPrintInterval(data.OutletCodes[0]).then(res => {
              commit('UPDATE_AUTO_PRINT', {
                outletCode: data.OutletCodes[0],
                isAutoPrint: !!res.data.data.IsAutoPrintReceipt,
                isPrintMenu: !!res.data.data.IsAutoPrintMenu,
                interval: res.data.data.PrintInterval || constants.PRINT_INTERVAL
              });
            }).catch(() => {
              commit('UPDATE_AUTO_PRINT', null);
            }).finally(() => {
              commit('SET_IS_PAGE_LOADING_USER', false);
            });
          } else {
            commit('SET_IS_PAGE_LOADING_USER', false);
            commit('UPDATE_AUTO_PRINT', null);
          } */
          commit('SET_IS_PAGE_LOADING_USER', false);
        }
      })
      .catch(err => {
        console.error(err);
        commit('UPDATE_CURRENT_USER', null);
        commit('UPDATE_AUTO_PRINT', null);
      });
  },
  LOAD_USER_PRIVILEGES({ commit }, uid) {
    if (uid.length === 0) {
      commit('UPDATE_USER_PRIVILEGES', false);
      return;
    }

    commit('SET_IS_PAGE_LOADING_PRIVILEGE', true);
    firebaseDB
      .collection('BACKOFFICE_USERS')
      .orderBy('CreatedAt')
      .limit(1)
      .get()
      .then(snapshot => {
        if (snapshot.empty) {
          commit('UPDATE_USER_PRIVILEGES', false);
        } else {
          commit('UPDATE_USER_PRIVILEGES', snapshot.docs[0].data().UID === uid);
        }
        commit('SET_IS_PAGE_LOADING_PRIVILEGE', false); // Change privilege loading state
      })
      .catch(err => {
        console.error(err);
        commit('UPDATE_USER_PRIVILEGES', false);
      });
  },
  USER_PAGE_PERMISSION({ commit }, permission) {
    commit('USER_PAGE_PERMISSION', permission);
  }
};
